import dynamic from 'next/dynamic';

export const Tag = dynamic(
  () => import('antd/lib/tag'),
  { ssr: false },
);
